import script from "./InquiryDetailAttachmentsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailAttachmentsSection.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailAttachmentsSection.vue?vue&type=style&index=0&id=b00bd9a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b00bd9a8"]])

export default __exports__